import React, { Component } from "react";
import ProductDialog from "../../components/settings/ProductDialog";
import CreateIcon from "@material-ui/icons/Create";
import IconButton from "@material-ui/core/IconButton";
import { languages } from "../../constants/languages";
import Button from "@material-ui/core/Button";
import moment from "moment-timezone";
import { isNormalInteger } from "../../util/IsNormalInteger";

class ProductContainer extends Component {
  state = {
    open: false,
    name: "",
    price: "",
    alwaysAdd: false,
    submitDisabled: true,
    trs: {},
    lang: "0",
  };

  handleCheck = (e) => {
    this.setState({
      alwaysAdd: !this.state.alwaysAdd,
      submitDisabled: this.state.name.length > 0 ? false : true,
    });
  };

  toggleDialog = () => {
    if (!this.state.open && this.props.product) {
      this.updateState(this.props.product);
    }
    this.setState({ open: !this.state.open });
  };

  UNSAFE_componentWillMount = () => {
    const product = this.props.product;
    if (product) {
      this.updateState(product);
    }
  };

  updateState = (product) => {
    this.setState({
      name: product.name || "",
      price: product.price || "",
      alwaysAdd: product.alwaysAdd || false,
      trs: product.trs || {},
    });
  };

  handleChange = (event) => {
    let newState = {};
    newState[event.target.name] = event.target.value;
    if (event.target.name === "name") {
      if (event.target.value.length > 0) {
        newState["submitDisabled"] = false;
      } else {
        newState["submitDisabled"] = true;
      }
    } else if (this.props.product) {
      newState["submitDisabled"] = false;
    }
    this.setState(newState);
  };

  handleTrsNameChange = (event) => {
    let trs = this.state.trs;
    trs[this.state.lang] = event.target.value;

    this.setState({ trs: trs });
  };

  handlePriceChange = (e) => {
    if (
      this.isValidPrice(e.target.value) ||
      isNormalInteger(e.target.value) ||
      e.target.value === ""
    ) {
      this.setState({ price: e.target.value, submitDisabled: false });
    }
  };

  isValidPrice = (str) => {
    // eslint-disable-next-line
    return /^\d+(?:\,\d{0,2})$/.test(str);
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ submitDisabled: true });
    this.toggleDialog();
    const tournamentRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);

    let products = this.props.tournament.products || {};

    if (this.props.product) {
      products[this.props.product.id]["name"] = this.state.name;
      products[this.props.product.id]["price"] = this.state.price;
      products[this.props.product.id]["alwaysAdd"] = this.state.alwaysAdd;
      products[this.props.product.id]["trs"] = this.state.trs;
    } else {
      let productId = moment().unix().toString();
      products[productId] = {};
      products[productId]["name"] = this.state.name;
      products[productId]["price"] = this.state.price;
      products[productId]["alwaysAdd"] = this.state.alwaysAdd;
      products[productId]["trs"] = this.state.trs;
    }

    let toUpdate = {};
    toUpdate["products"] = products;

    tournamentRef
      .update(toUpdate)
      .then(() => {
        if (this.props.product) {
          this.setState({ submitDisabled: true });
        } else {
          this.setState({
            submitDisabled: true,
            name: "",
            price: "",
            alwaysAdd: false,
            trs: {},
            lang: "0",
          });
        }
      })
      .catch((error) => {
        this.setState({ submitDisabled: false });
      });
  };

  render() {
    return (
      <div>
        {this.props.product ? (
          <IconButton
            aria-label="Change"
            onClick={this.toggleDialog}
            disabled={this.props.disabled}
            style={{ height: 30, width: 30 }}
          >
            <CreateIcon
              style={{ height: 20, width: 20, position: "absolute", top: 5 }}
            />
          </IconButton>
        ) : (
          <Button
            variant="outlined"
            color="default"
            onClick={this.toggleDialog}
            fullWidth
          >
            {languages.signupPage.addProduct}
          </Button>
        )}
        <ProductDialog
          name={
            this.state.lang !== "0"
              ? this.state.trs[this.state.lang] || ""
              : this.state.name
          }
          submitDisabled={this.state.submitDisabled}
          open={this.state.open}
          price={this.state.price}
          alwaysAdd={this.state.alwaysAdd}
          product={this.props.product}
          toggleDialog={this.toggleDialog}
          handleChange={this.handleChange}
          handleSubmit={this.handleSubmit}
          tournament={this.props.tournament}
          handleCheck={this.handleCheck}
          handlePriceChange={this.handlePriceChange}
          lang={this.state.lang}
          handleTrsNameChange={this.handleTrsNameChange}
        />
      </div>
    );
  }
}

export default ProductContainer;
